import { ZH, EN } from '@yaotai/common-utils';

const EMAIL_LOGIN_LOCALE = {
    [ZH]: {
        emailNotNull: '邮箱地址不能为空',
        incorrectEmail: '邮箱格式不正确',
        noCorpEmail: '抱歉，暂不支持 corp 邮箱帐号注册登录',
        notRegisteredNetEaseYaotai: '该邮箱未注册瑶台帐号，',
        goToRegister: '请注册帐号',
        enterEmail: '请输入您的邮箱',
        passwordNotNull: '密码不能为空',
        accountOrPasswordError: '用户名或密码错误',
        password: '请输入密码',
        clickToVerify: '请先完成点击验证',
        agreeTermsOfService: '您需要同意相关条款才能使用',
        readAndAgree: '我同意',
        termsOfService: '《服务条款》',
        and: '、',
        netEasePrivacyPolicy: '《隐私政策》',
        login: '登录',
        forgotPassword: '忘记密码',
        noAccount: '没有帐号？',
        createAccount: '立即注册',
        contactCustomerService: '请电话联系客服找回密码',
        ContactCustomerService: '知道了',
    },
    [EN]: {
        emailNotNull: 'Cannot be null',
        incorrectEmail: 'Incorrect email format',
        noCorpEmail: 'Sorry, the corp email is not supported for registration',
        notRegisteredNetEaseYaotai: 'Email is not registered NetEase Yaotai, ',
        goToRegister: 'go to register',
        enterEmail: 'Enter e-mail',
        passwordNotNull: 'Cannot be null',
        accountOrPasswordError: 'Account or Password error',
        password: 'Password',
        clickToVerify: 'Please click to verify first',
        agreeTermsOfService: 'You need to agree to the relevant terms to use',
        readAndAgree: ' I have read and agree to the',
        termsOfService: ' terms of service ',
        and: 'and',
        netEasePrivacyPolicy: ' NetEase privacy policy ',
        login: 'Log in',
        forgotPassword: 'Forgot password?',
        noAccount: '',
        createAccount: 'Create Account',
        contactCustomerService: 'Please contact customer service by phone to retrieve your password',
        ContactCustomerService: 'Got it',
    },
};

export { EMAIL_LOGIN_LOCALE };
